<ion-app [class.super-admin]="isSuperAdminPage()">
  <ng-template #menuTemplate>
  <ion-menu contentId="main-content" menuId="main-menu" [type]="is_admin ? 'push' : 'overlay'" side="end" (ionWillOpen)="scrollActiveMenuIntoView()">
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-menu-toggle class="main-menu">
          <ion-button class="header-round-btn">
            <ion-icon name="arrow-back-outline"></ion-icon>
          </ion-button>
        </ion-menu-toggle>
      </ion-toolbar>
      <div class="profile-container">
        <ngx-avatars [name]="currentUser?.name" [src]="currentUser?.profile_picture_url" initialsSize="3" size="175" ></ngx-avatars>
        <ion-text>
          <h3 class="ion-no-margin ion-margin-top">{{currentUser?.name}} {{currentUser?.surname}}</h3>
        </ion-text>
        @if(!is_guest && !is_admin)
        {
            <ion-menu-toggle auto-hide="true">
              <div class="my_profile">
                <span [routerLink]="[ 'tabs/my-profil-account' ]">
                  {{'nav.menu.my_profile' | translate | titlecase}}
                </span>
              </div>
            </ion-menu-toggle>
        }
      </div>
    </ion-header>
    <ion-content [fullscreen]="true">
      <ion-list id="inbox-list">
        <ng-container *ngIf="is_admin else regularUser"> <!-- MENU SUPER ADMIN -->
          <!--Dashboard -->
          <ion-menu-toggle auto-hide="false">
            <ion-item button lines="none" detail="false" class="no-container" routerLink="/super-admin/dashboard"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon slot="start" name="home"></ion-icon>
              <ion-label>{{'menu_dashboard' | translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!--Dashboard -->

          <!-- Prayer Video -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false" routerLink="/super-admin/prayer-video"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon slot="start" name="caret-forward-circle-outline"></ion-icon>
              <ion-label>{{ 'common.prayer_videos' | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Prayer Video -->
          <!-- Bless Challenge Content -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false" routerLink="/super-admin/bless-day-template"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon slot="start" name="calendar-outline"></ion-icon>
              <ion-label>{{ 'common.bless_challenge_content' | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Bless Challenge Content -->

          <!-- Bless Challenge Home Page Video -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false"
              routerLink="/super-admin/bless-challenge-video-homepage" routerDirection="root"
              routerLinkActive="selected">
              <ion-icon slot="start" name="calendar-outline"></ion-icon>
              <ion-label>{{ 'bless_challenge_video_for_hp' | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Bless Challenge Home Page Video -->

          <!-- Prayer Card -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false" routerLink="/super-admin/prayer-card"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon slot="start" name="reader-outline"></ion-icon>
              <ion-label>{{ 'common.prayer_cards' | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Prayer Card -->

          <!-- Prayer News -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false" routerLink="/super-admin/prayer-news"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon slot="start" src="/assets/icon/buttons/Icon_247PrayerRoom.svg"></ion-icon>
              <ion-label>{{ 'prayer_news' | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- End Prayer News -->

          <!-- Media&Resources -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false" routerLink="/super-admin/media-resource"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon aria-hidden="true" slot="start" src="/assets/icon/menu/Icon_MediaResources.svg"></ion-icon>
              <ion-label>{{'nav.menu.media_and_resources' | translate | uppercase }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- End Media&Resources -->

          <!-- Global Update Moderation -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false" routerLink="/super-admin/global-updates"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon name="alert-circle-outline" slot="start"></ion-icon>
              <ion-label>{{ 'pray_for_all_global_update' | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Global Update Moderation -->

          <!-- Learn More Content -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false" routerLink="/super-admin/learn-more-content"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon slot="start" name="information-circle-outline"></ion-icon>
              <ion-label>{{ 'common.learn_more_content' | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Learn More Content -->

          <!--Support -->
          <ion-menu-toggle auto-hide="false">
            <ion-item button lines="none" detail="false" class="no-container" routerLink="/super-admin/support"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon name="chatbubble-ellipses" slot="start"></ion-icon>
              <ion-label>{{'common.support' | translate | uppercase }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!--Support -->
          <!-- localization link -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item class="no-container" detail="false" routerLink="/super-admin/translation" routerDirection="root"
              routerLinkActive="selected">
              <ion-icon slot="start" name="language"></ion-icon>
              <ion-label>{{'languages' | translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- localization link -->

          <!-- bless challenge daily notification -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item class="no-container" detail="false" routerLink="/super-admin/bless-challenge-notification"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon name="notifications" slot="start"></ion-icon>
              <ion-label>{{'bless_challenge_daily_notification' | translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- bless challenge daily notification -->

          <!-- New Church Registrations -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item class="no-container" detail="false" routerLink="/super-admin/new-church-register"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon slot="start" name="ellipse"></ion-icon>
              <ion-label>{{ 'common.organizations' | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- New Church Registrations -->
          <!-- New PMD Registrations -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false" routerLink="/super-admin/new-pmd-register"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon slot="start" name="ellipse"></ion-icon>
              <ion-label>{{ 'common.pmd' | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- New PMD Registrations -->

          <!-- Communication center -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false"
              routerLink="/super-admin/communication-center" routerDirection="root" routerLinkActive="selected">
              <ion-icon slot="start" name="mail-open-outline"></ion-icon>
              <ion-label>{{'common.communication_center' | translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Communication center -->

          <!-- Pray For All Reports -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false"
              routerLink="/super-admin/prayer-reports/pray-for-all-prayer-report" routerDirection="root"
              routerLinkActive="selected">
              <ion-icon slot="start" name="bar-chart"></ion-icon>
              <ion-label>{{'common.pray_for_all_reports' | translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Pray For All Reports -->

          <!-- Empower -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false" routerLink="/super-admin/empower"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon slot="start" name="id-card"></ion-icon>
              <ion-label>{{'common.empower' | translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <!-- Giving -->
          <ion-menu-toggle class="menu-items" [autoHide]="false">
            <ion-item *ngIf="is_admin" class="no-container" detail="false" routerLink="/super-admin/giving"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon aria-hidden="true" slot="start" src="/assets/icon/tabs/Icon_Giving.svg"></ion-icon>
              <ion-label>{{'common.giving' | translate}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Giving -->

          <ion-menu-toggle [autoHide]="false">
            <ion-item *ngIf="is_admin" button lines="none" detail="false" class="no-container" (click)="logout()">
              <ion-icon aria-hidden="true" slot="start" name="exit"></ion-icon>
              <ion-label>{{'logout' | translate | uppercase }}</ion-label>
            </ion-item>
          </ion-menu-toggle>

        </ng-container>
        <ng-template #regularUser>
          <!-- GIVING MENU -->
          <ion-menu-toggle auto-hide="true" *ngIf="!isProductionEnv">
            <ion-item routerDirection="root" routerLink="tabs/giving" lines="none" detail="false"
              routerLinkActive="selected" class="no-container">
              <ion-icon src="/assets/icon/tabs/Icon_Giving.svg" class="ion-margin-end"></ion-icon>
              <ion-label>{{'nav.tabs.giving' | translate | uppercase}}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- END GIVING MENU -->

          <ion-menu-toggle auto-hide="true" *ngIf="!isProductionEnv">
            <ion-item routerDirection="root" routerLink="tabs/media-resources" lines="none" detail="false"
              routerLinkActive="selected" class="no-container">
              <ion-icon aria-hidden="true" slot="start" src="/assets/icon/menu/Icon_MediaResources.svg"></ion-icon>
              <ion-label>{{'nav.menu.media_and_resources' | translate | uppercase }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="true" *ngIf="!isProductionEnv">
            <ion-item routerDirection="root" routerLink="tabs/invite" lines="none" detail="false"
              routerLinkActive="selected" class="no-container">
              <ion-icon aria-hidden="true" slot="start" src="/assets/icon/menu/Icon_Invite.svg"></ion-icon>
              <ion-label>{{'nav.menu.Invite' | translate | uppercase }}</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <!-- support link -->
          <ion-menu-toggle auto-hide="true">
            <ion-item button lines="none" detail="false" class="no-container" routerLink="/tabs/chat-list"
              routerDirection="root" routerLinkActive="selected">
              <ion-icon name="chatbubble-ellipses" slot="start"></ion-icon>
              <ion-label>{{'common.support' | translate | uppercase }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- support link -->
          <!-- regular user logout -->
          @if(!is_guest){
          <ion-menu-toggle auto-hide="true">
            <ion-item button lines="none" detail="false" class="no-container" (click)="logout()">
              <ion-icon aria-hidden="true" slot="start" src="/assets/icon/menu/Icon_Logout.svg"></ion-icon>
              <ion-label>{{'logout' | translate | uppercase }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          } @else {
          <ion-menu-toggle>
            <ion-item button lines="none" detail="false" class="no-container" routerLink="/auth/create-account"
              [queryParams]="{tab: 'login'}" routerDirection="root">
              <ion-icon aria-hidden="true" slot="start" src="/assets/icon/menu/Icon_Login.svg"></ion-icon>
              <ion-label>{{'login' | translate | uppercase }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          }
        </ng-template>
      </ion-list>
    </ion-content>
  </ion-menu>
  </ng-template>
  <div class="top-header-content" *ngIf="!hideTopBar"></div>
  <div class="app-container">
    <ng-container *ngIf="is_admin; else noSplitPane">
      <ion-split-pane contentId="main-content" [when]="'lg'" class="super-admin-split-pane">
        <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
        <ng-container *ngTemplateOutlet="mainContent"></ng-container>
      </ion-split-pane>
    </ng-container>

    <ng-template #noSplitPane>
      <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="mainContent"></ng-container>
    </ng-template>

    <ng-template #mainContent>
      <ion-router-outlet id="main-content" [class.super-admin]="isSuperAdminPage()"></ion-router-outlet>
    </ng-template>
  </div>

</ion-app>